import {
  SET_INITIAL_FILTER_INFO,
  SET_CURRENT_FILTER_INFO,
  UPDATE_AIRLINE_FILTERS_UI,
  UPDATE_AIRLINE_FILTERS_REQ,
  UPDATE_ATTRIBUTES_FILTERS_REQ,
  UPDATE_STOPS_FILTERS_UI,
  UPDATE_STOPS_FILTERS_REQ,
  UPDATE_TIME_FILTERS,
  RESET_TIME_FILTERS,
  UPDATE_AIRPORTS_FILTERS_UI,
  UPDATE_AIRPORTS_FILTERS_REQ,
  UPDATE_EXACT_DATE_FILTERS_REQ,
  UPDATE_EXACT_DATE_FILTERS_UI,
  UPDATE_INCLUDED_CARRIERS,
  UPDATE_ATTRIBUTES_FILTERS_UI,
} from './actionTypes'

export function setInitialFilterInfo(payload, sbsParams = {}) {
  return {
    type: SET_INITIAL_FILTER_INFO,
    payload,
    sbsParams,
  }
}

export function setCurrentFilterInfo(payload) {
  return {
    type: SET_CURRENT_FILTER_INFO,
    payload,
  }
}

export function updateAirlineFiltersUI(payload, meta) {
  return {
    type: UPDATE_AIRLINE_FILTERS_UI,
    payload,
    meta,
  }
}

/**
 * Attributes Filter
 * */

export function updateAttributesFiltersUI({ payload, meta }) {
  return {
    type: UPDATE_ATTRIBUTES_FILTERS_UI,
    payload,
    meta,
  }
}

export function updateAttributesFiltersReq(
  payload,
  meta,
  attributes,
  sbsParams = {}
) {
  return {
    type: UPDATE_ATTRIBUTES_FILTERS_REQ,
    payload,
    meta,
    attributes,
    sbsParams,
  }
}

export function updateAirlineFiltersReq(
  payload,
  meta,
  airlines,
  sbsParams = {}
) {
  return {
    type: UPDATE_AIRLINE_FILTERS_REQ,
    payload,
    meta,
    airlines,
    sbsParams,
  }
}

export function updateIncludedCarriers(payload) {
  return {
    type: UPDATE_INCLUDED_CARRIERS,
    payload,
  }
}

export function updateStopsFiltersUI(payload, meta) {
  return {
    type: UPDATE_STOPS_FILTERS_UI,
    payload,
    meta,
  }
}

export function updateStopsFiltersReq(payload, meta, sbsParams = {}) {
  return {
    type: UPDATE_STOPS_FILTERS_REQ,
    payload,
    meta,
    sbsParams,
  }
}

export function updateTimeFilters(payload, entity, sliceRefId, sbsParams = {}) {
  return {
    type: UPDATE_TIME_FILTERS, // This calls 2 reducers of the same name, one in timeFilters.js, one in filterInfo.js
    payload,
    entity,
    sliceRefId,
    sbsParams,
  }
}

export function resetTimeFilters(entity) {
  return {
    type: RESET_TIME_FILTERS,
    entity,
  }
}

export function updateAirportsFiltersUI(payload, meta = {}, entity) {
  return {
    type: UPDATE_AIRPORTS_FILTERS_UI,
    payload,
    meta,
    entity,
  }
}

export function updateAirportsFiltersReq(
  payload,
  entity,
  meta = {},
  sbsParams = {}
) {
  return {
    type: UPDATE_AIRPORTS_FILTERS_REQ,
    payload,
    entity,
    meta,
    sbsParams,
  }
}

export function updateExactDateFiltersUI(payload, entity) {
  return {
    type: UPDATE_EXACT_DATE_FILTERS_UI,
    payload,
    entity,
  }
}

export function updateExactDateFiltersReq(payload, entity) {
  return {
    type: UPDATE_EXACT_DATE_FILTERS_REQ,
    payload,
    entity,
  }
}
